<template>
  <div class="p-5">
    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <p>null</p>
<!--        <CustomerBorrowerEdit />-->
      </div>
    </div>
  </div>
</template>

<script>
// import CustomerBorrowerEdit from '@/views/pages/Customer/Borrower/edit.vue'

export default {
  components: {
    // CustomerBorrowerEdit
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
